import { Check } from 'lucide-react'
import { cn } from '@/lib/tailwind.utils'
import { WizardStep } from '../../documents-upload.types'

type UploadWizardStepsProps = {
  steps: Record<string, string>
  currentStep: WizardStep
  completedSteps: Partial<Record<WizardStep, boolean>>
  onSelectStep: (step: WizardStep) => void
}

export const UploadWizardSteps = ({
  steps,
  currentStep,
  completedSteps,
  onSelectStep,
}: UploadWizardStepsProps) => {
  const stepKeys = Object.keys(steps) as WizardStep[]

  return (
    <ol className="flex flex-wrap items-center gap-x-4 gap-y-2">
      {stepKeys.map((step, index) => {
        const active = step === currentStep
        const completed = completedSteps[step] === true
        const visited = stepKeys.slice(0, index).some((s) => completedSteps[s]) || active
        const clickable = visited || completed

        return (
          <li key={step}>
            <button
              type="button"
              disabled={!clickable}
              onClick={() => onSelectStep(step)}
              className={cn(
                'flex items-center gap-2 text-sm disabled:cursor-not-allowed',
                active ? 'font-medium text-foreground' : 'text-muted-foreground',
              )}
            >
              <span
                className={cn(
                  'flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-medium',
                  completed && 'bg-emerald-100 text-emerald-600',
                  active && 'bg-primary text-primary-foreground',
                  !completed && !active && 'bg-muted text-muted-foreground',
                )}
              >
                {completed && !active ? <Check className="h-3.5 w-3.5" /> : index + 1}
              </span>
              {steps[step]}
            </button>
          </li>
        )
      })}
    </ol>
  )
}
